import LoginPanel from "../components/Login/LoginPanel";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import * as actions from "../common/actions";
import { updateUUID } from "../common/actions";
import { All, KeyValue } from "../interfaces";

export function mapStateToProps({ appState }: All) {
  return {
    appState: (appState as KeyValue)[appState.app],
    banner: appState.banner,
  };
}

function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    updateUUID: (uuid: string) => {
      dispatch(updateUUID(uuid));
    },
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(LoginPanel);
